import { GenerateUploadUrlsRequest } from '../models/GenerateUploadUrlsRequest';
import { GenerateUploadUrlsResponse } from '../models/GenerateUploadUrlsResponse';
import { authService } from '../services/AuthService';
import { hostApiClient } from '../hostApiClient';
import { userApiClient } from '../userApiClient';
import { tutorApiClient } from '../tutorApiClient';

function generateUploadUrlsForRole(request: GenerateUploadUrlsRequest): Promise<GenerateUploadUrlsResponse> {
  const roles = authService.getRoles();
  if (roles.includes('HOST')) {
    return hostApiClient.generateUploadUrls(request);
  }
  if (roles.includes('TUTOR')) {
    return tutorApiClient.generateUploadUrls(request);
  }
  return userApiClient.generateUploadUrls(request);
}

/**
 * Upload via role-scoped POST …/assets/upload-urls + presigned PUT; returns accessAt for API payloads.
 * Routes: HOST → /v1/host, TUTOR → /v1/tutor, otherwise → /v1/user.
 */
export async function uploadAssetFile(
  file: File,
  onProgress?: (progress: number) => void
): Promise<string> {
  const ext = file.name.split('.').pop() || 'jpg';
  const res = await generateUploadUrlsForRole({ fileExtensions: [ext] });
  const url = res.uploadUrls[0];
  await hostApiClient.uploadToPresignedUrl(url.uploadTo, file, onProgress);
  return url.accessAt;
}
